import { Buffer } from "buffer";
import Cookies from 'js-cookie'
import { jwtDecode } from "jwt-decode";
import crypto from "crypto";


const BASE_URL = "/api/v1/auth"

function base64URLEncode(str: Buffer) {
	return str.toString('base64')
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.replace(/=/g, '');
}

export async function RefreshToken(code: string) {
    const url = `${BASE_URL}/login/sso/refresh`;

    let response = await fetch(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                refreshToken: code
            }),
        });
    if (response.ok) {
        const response_data = await response.json();
        Cookies.set("__session", response_data.response, { sameSite: 'Strict' });
        return jwtDecode(response_data.response);
    } else {
        throw new Error(response.statusText)
    }
}



export async function GetSsoToken(code: string) {
    const url = `${BASE_URL}/login/sso/token`;
    const verifier = sessionStorage.getItem('verifier');
    const email = sessionStorage.getItem('email');

    let redirect_uri = window.location.protocol + '//'+window.location.host+'/auth';

    let response = await fetch(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: code,
                verifier: verifier,
                redirectURL: redirect_uri,
                email
            }),
        });
    if (response.ok) {
        const response_data = await response.json();
        Cookies.set("__session", response_data.response, { sameSite: 'Strict' });
        return jwtDecode(response_data.response);
    } else {
        throw new Error(response.statusText)
    }
}

async function getSsoUrlFromBackend(user: string) {
    const url = `${BASE_URL}/login/sso?email=` + user;

    let response = await fetch(url,
        {
            method: "GET"
        });
    if (response.ok) {
        const responseData = await response.json();
        return responseData.response;
    } else {
        throw new Error(response.statusText)
    }
}

function sha256(buffer: Buffer) {
	return crypto.createHash('sha256').update(buffer).digest();
}


export async function getSSOUrl(user: string) {
    try {

        let ssoConfig = await getSsoUrlFromBackend(user)
        const verifier = base64URLEncode(crypto.randomBytes(32));
        const challenge = base64URLEncode(sha256(Buffer.from(verifier)));
        const ssoURL = new URL(ssoConfig);
        const redirect = new URL(window.location.protocol + '//'+window.location.host+'/auth');
        ssoURL.searchParams.append('response_type', 'code');
        ssoURL.searchParams.append('redirect_uri', redirect.toString());
        ssoURL.searchParams.append('code_challenge', challenge);
        ssoURL.searchParams.append('code_challenge_method', 'S256');

        sessionStorage.setItem('verifier', verifier);
        sessionStorage.setItem('email', user);
        return ssoURL.toString();
    } catch (e) {
        console.log(e)
        throw Error("An error occured while logging in");
    }
}
